export default __webpack_public_path__ + "static/media/TwitterIcon.2c3292f4.svg";